module.exports = __webpack_public_path__ + "img/NC_jinsong_2021.6438cc9e.png";